import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from './App';
import { onCLS, onFCP, onFID, onLCP, onTTFB } from 'web-vitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Exemple d'utilisation des Web Vitals avec leurs handlers
onCLS((metric) => {
  console.log('Cumulative Layout Shift (CLS):', metric);
});
onFCP((metric) => {
  console.log('First Contentful Paint (FCP):', metric);
});
onFID((metric) => {
  console.log('First Input Delay (FID):', metric);
});
onLCP((metric) => {
  console.log('Largest Contentful Paint (LCP):', metric);
});
onTTFB((metric) => {
  console.log('Time to First Byte (TTFB):', metric);
});
